import { z } from "zod";
import { safeMfaReturnTo } from "../utils/mfaRouting";

export const mfaSearchSchema = z.object({
    returnTo: z.string().optional().transform(safeMfaReturnTo),
});
